export default __webpack_public_path__ + "static/media/output-onlinepngtools.78659d9a.png";